import React from 'react';

const NullComponent = () => <></>;

export default NullComponent;
